// Check if there is any supported locale in the pathname
export function isPathnameMissingLocale({
  locales,
  pathname,
}: {
  locales: string[];
  pathname: string;
}) {
  return locales.every(
    (locale) => !pathname.startsWith(`/${locale}/`) && pathname !== `/${locale}`,
  );
}
